export const assetBaseUrl = '/asset-manager/api/';
